var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hero',{attrs:{"heading":"Damien Robinson","subheading":"Web Development"}}),_vm._v(" "),_c('Features'),_vm._v(" "),_c('Services'),_vm._v(" "),_c('ContactUs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }